var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 3.26562C10.2097 3.26562 8.75342 4.72184 8.75342 6.51201C8.75342 8.30219 10.2096 9.75841 11.9998 9.75841C13.79 9.75841 15.2462 8.30214 15.2462 6.51201C15.2462 4.72189 13.79 3.26562 11.9998 3.26562ZM11.9998 8.83084C10.7217 8.83084 9.68098 7.79014 9.68098 6.51201C9.68098 5.23389 10.7217 4.19319 11.9998 4.19319C13.2779 4.19319 14.3186 5.23389 14.3186 6.51201C14.3186 7.79014 13.278 8.83084 11.9998 8.83084Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4929 6.97583C17.2148 6.97583 16.1741 8.01653 16.1741 9.29466C16.1741 10.5728 17.2148 11.6135 18.4929 11.6135C19.771 11.6135 20.8117 10.5728 20.8117 9.29466C20.8117 8.01653 19.771 6.97583 18.4929 6.97583ZM18.4929 10.686C17.7258 10.686 17.1016 10.0617 17.1016 9.29466C17.1016 8.52757 17.7258 7.90335 18.4929 7.90335C19.26 7.90335 19.8842 8.52757 19.8842 9.29466C19.8842 10.0617 19.2599 10.686 18.4929 10.686Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57322 6.97583C4.29413 6.97583 3.25439 8.01653 3.25439 9.29466C3.25439 10.5728 4.29509 11.6135 5.57322 11.6135C6.85135 11.6135 7.89205 10.5728 7.89205 9.29466C7.89205 8.01653 6.85227 6.97583 5.57322 6.97583ZM5.57322 10.686C4.80613 10.686 4.18192 10.0617 4.18192 9.29466C4.18192 8.52757 4.80613 7.90335 5.57322 7.90335C6.34031 7.90335 6.96453 8.52757 6.96453 9.29466C6.96453 10.0617 6.34027 10.686 5.57322 10.686Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 10.686C8.67564 10.686 5.97095 13.3907 5.97095 16.715C5.97095 16.971 6.17873 17.1788 6.43473 17.1788C6.69073 17.1788 6.89851 16.971 6.89851 16.715C6.89851 13.9018 9.18673 11.6136 11.9999 11.6136C14.8132 11.6136 17.1014 13.9018 17.1014 16.715C17.1014 16.971 17.3092 17.1788 17.5652 17.1788C17.8212 17.1788 18.0289 16.971 18.0289 16.715C18.0289 13.3907 15.3242 10.686 11.9999 10.686Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4928 12.541C17.7295 12.541 16.9818 12.7497 16.3307 13.1439C16.1128 13.2775 16.3195 13.3698 16.4522 13.5887C16.5867 13.8076 16.5932 14.0696 16.8121 13.937C17.3176 13.6299 17.8982 13.4685 18.4928 13.4685C20.2829 13.4685 21.7392 14.9248 21.7392 16.7149C21.7392 16.9709 21.947 17.1787 22.203 17.1787C22.459 17.1787 22.6668 16.9709 22.6668 16.7149C22.6667 14.4137 20.794 12.541 18.4928 12.541Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66833 13.143C7.01812 12.7497 6.27055 12.541 5.50716 12.541C3.20595 12.541 1.33325 14.4137 1.33325 16.7149C1.33325 16.9709 1.54103 17.1787 1.79703 17.1787C2.05303 17.1787 2.26082 16.9709 2.26082 16.7149C2.26077 14.9248 3.71703 13.4685 5.50716 13.4685C6.10173 13.4685 6.68234 13.6299 7.18694 13.936C7.4049 14.0687 7.35316 13.8587 7.48672 13.6398C7.62029 13.4209 7.8872 13.2765 7.66833 13.143Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customersIcon.e7922d9ae82826ed5948249460989782.svg";
export { ForwardRef as ReactComponent };